export default "__VITE_ASSET__BYiJ5drQ__"